import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Icon } from '../../../layout/Icon.jsx';
import { useAuth } from '../../../shared/useAuth.js';
import { useShiftStatus, useShiftUI } from '../../../shared/useShift.js';
import { useDuration } from '../../../shared/useDuration.js';

const CASH_OPERATOR_PERMS = [
  'checkout.settle', 'reception.create_session', 'reception.issue_card',
  'pos.cafeteria.sell', 'pos.toys.sell', 'shifts.manage'
];

/** شارة الشفت في الشريط العلوي: الحالة + فتح/تقرير/إقفال. */
export function ShiftBadge() {
  const navigate = useNavigate();
  const hasPermission = useAuth((s) => s.hasPermission);
  const { shift, loading } = useShiftStatus();
  const openModal = useShiftUI((s) => s.openModal);
  const [menu, setMenu] = useState(false);
  const ref = useRef(null);
  const duration = useDuration(shift?.openedAt, 30_000);

  useEffect(() => {
    function onClick(e) {
      if (ref.current && !ref.current.contains(e.target)) setMenu(false);
    }
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, []);

  const isOperator = CASH_OPERATOR_PERMS.some((p) => hasPermission(p));
  const canManage = hasPermission('shifts.view') || hasPermission('shifts.manage');
  if (loading || (!isOperator && !canManage)) return null;

  if (!shift) {
    if (!isOperator) return null;
    return (
      <button
        type="button"
        className="btn"
        style={{ borderColor: '#FDBA74', background: '#FFF7ED', color: '#9A3412', fontSize: 12.5 }}
        onClick={() => openModal('open')}
        title="لا يوجد شفت مفتوح"
      >
        <Icon name="clock" size={14} /> فتح شفت
      </button>
    );
  }

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        className="flex items-center gap-2 px-3 py-2 rounded-[10px] border shadow-card text-[12.5px]"
        style={{ borderColor: '#86EFAC', background: '#F0FDF4', color: '#166534' }}
        onClick={() => setMenu((v) => !v)}
      >
        <span className="w-2 h-2 rounded-full" style={{ background: '#22C55E' }} />
        <span className="font-bold">شفت مفتوح</span>
        <span className="text-[11.5px] opacity-80">{shift.cashboxName} • {duration.formatted}</span>
      </button>
      {menu ? (
        <div className="absolute left-0 mt-1.5 w-56 bg-white border border-line rounded-[12px] shadow-pop z-20 overflow-hidden">
          <button
            type="button"
            className="w-full text-right px-3 py-2.5 hover:bg-paper-2 text-[13px] flex items-center gap-2"
            onClick={() => { setMenu(false); openModal('report', { reportShiftId: shift._id }); }}
          >
            <Icon name="print" size={14} /> تقرير الشفت
          </button>
          <button
            type="button"
            className="w-full text-right px-3 py-2.5 hover:bg-paper-2 text-[13px] flex items-center gap-2 text-red"
            onClick={() => { setMenu(false); openModal('close', { closeShiftId: shift._id }); }}
          >
            <Icon name="check" size={14} /> إقفال الشفت
          </button>
          {canManage ? (
            <button
              type="button"
              className="w-full text-right px-3 py-2.5 hover:bg-paper-2 text-[13px] flex items-center gap-2 border-t border-line"
              onClick={() => { setMenu(false); navigate('/shifts'); }}
            >
              <Icon name="clock" size={14} /> إدارة الشفتات
            </button>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
